import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=097d3d4e&scoped=true&"
import script from "./DefaultView.vue?vue&type=script&lang=js&"
export * from "./DefaultView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=097d3d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097d3d4e",
  null
  
)

export default component.exports